module.exports = __webpack_public_path__ + "statics/img/bottom.38480c03.png";